import { Component } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-demo-api-spec',
  imports: [],
  templateUrl: './breadcrumb-demo-api-spec.component.html',
  styleUrl: './breadcrumb-demo-api-spec.component.scss',
})
export class BreadcrumbDemoApiSpecComponent {}
